<template>
  <div class="localidades-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :pais="pais"
          :provincia="provincia"
          @filtrar="filtrar">
        </app-filtro>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Localidades">
          <b-table 
              hover
              responsive="sm" 
              class="registro" 
              :busy="tableBusy"
              :items="localidades" 
              :fields="localidadesFields"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            
            <template v-slot:cell(opciones)="data" v-if="accesoABM">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos de la Localidad</b-dropdown-item>
                <!--
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Borrar</b-dropdown-item>
                -->
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn" v-if="accesoABM">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from  './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'localidades/getField',
  mutationType: 'localidades/updateField',
});

export default {
  name: 'LocalidadesList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  data: () => {
    return {
      localidadesFields: [
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'provincia',
          sortable: true
        },
        {
          key: 'pais',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center', 
        },
      ],

      tableBusy: false,
      accesoABM: false,
    }
  },
  computed: {
    ...mapFields([
      'localidades',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'pais',
      'provincia'
    ]),
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 6: /* Director Administrativo */
      case 7: /* Asistente de Administracion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
      case 10: /* Asistente de Logística */
      case 21: /* Responsable de Finanzas y Proveedores */
      case 22: /* Responsable de Facturacion e Impuestos */
      case 23: /* Asistente de Calidad */
        this.accesoABM = true;
        break;
    }

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.pais = filtro.pais;
      this.provincia = filtro.provincia;
      this.paginaActual = 1;

      this.getItems();      
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('localidades/getLocalidades')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error))
    },
    consultar (item) {
      this.$router.push({ name: 'LocalidadData', 
                          params: { id: item.id }});
    },
    editar (item) {
      if (this.accesoABM) {
        this.$router.push({ name: 'LocalidadABM', 
                            params: { id: item.id }});
      }
    },
    agregar () {
      if (this.accesoABM) {
        this.$router.push({ name: 'LocalidadABM', 
                            params: { id: 0 }});
      }
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
.localidades-list .registro table td {
  vertical-align: middle;
}
.localidades-list .registro table td[aria-colindex="1"] {
  width: calc(40% - 40px);
}
.localidades-list .registro table td[aria-colindex="2"] {
  width: 30%;
}
.localidades-list .registro table td[aria-colindex="3"] {
  width: 30%;
}
.localidades-list .registro table td[aria-colindex="4"] {
  width: 40px;
}
</style>
